const phonecode = [
  {
    "COUNTRY": "Afghanistan",
    "CODE": "93",
    "LOCAL": "AF"
  },
  {
    "COUNTRY": "Albania",
    "CODE": "355",
    "LOCAL": "AL"
  },
  {
    "COUNTRY": "Algeria",
    "CODE": "213",
    "LOCAL": "DZ"
  },
  {
    "COUNTRY": "American Samoa",
    "CODE": "1-684",
    "LOCAL": "AS"
  },
  {
    "COUNTRY": "Andorra",
    "CODE": "376",
    "LOCAL": "AD"
  },
  {
    "COUNTRY": "Angola",
    "CODE": "244",
    "LOCAL": "AO"
  },
  {
    "COUNTRY": "Anguilla",
    "CODE": "1-264",
    "LOCAL": "AI"
  },
  {
    "COUNTRY": "Antarctica",
    "CODE": "672",
    "LOCAL": "AQ"
  },
  {
    "COUNTRY": "Antigua and Barbuda",
    "CODE": "1-268",
    "LOCAL": "AG"
  },
  {
    "COUNTRY": "Argentina",
    "CODE": "54",
    "LOCAL": "AR"
  },
  {
    "COUNTRY": "Armenia",
    "CODE": "374",
    "LOCAL": "AM"
  },
  {
    "COUNTRY": "Aruba",
    "CODE": "297",
    "LOCAL": "AW"
  },
  {
    "COUNTRY": "Australia",
    "CODE": "61",
    "LOCAL": "AU"
  },
  {
    "COUNTRY": "Austria",
    "CODE": "43",
    "LOCAL": "AT"
  },
  {
    "COUNTRY": "Azerbaijan",
    "CODE": "994",
    "LOCAL": "AZ"
  },
  {
    "COUNTRY": "Bahamas",
    "CODE": "1-242",
    "LOCAL": "BS"
  },
  {
    "COUNTRY": "Bahrain",
    "CODE": "973",
    "LOCAL": "BH"
  },
  {
    "COUNTRY": "Bangladesh",
    "CODE": "880",
    "LOCAL": "BD"
  },
  {
    "COUNTRY": "Barbados",
    "CODE": "1-246",
    "LOCAL": "BB"
  },
  {
    "COUNTRY": "Belarus",
    "CODE": "375",
    "LOCAL": "BY"
  },
  {
    "COUNTRY": "Belgium",
    "CODE": "32",
    "LOCAL": "BE"
  },
  {
    "COUNTRY": "Belize",
    "CODE": "501",
    "LOCAL": "BZ"
  },
  {
    "COUNTRY": "Benin",
    "CODE": "229",
    "LOCAL": "BJ"
  },
  {
    "COUNTRY": "Bermuda",
    "CODE": "1-441",
    "LOCAL": "BM"
  },
  {
    "COUNTRY": "Bhutan",
    "CODE": "975",
    "LOCAL": "BT"
  },
  {
    "COUNTRY": "Bolivia",
    "CODE": "591",
    "LOCAL": "BO"
  },
  {
    "COUNTRY": "Bosnia and Herzegovina",
    "CODE": "387",
    "LOCAL": "BA"
  },
  {
    "COUNTRY": "Botswana",
    "CODE": "267",
    "LOCAL": "BW"
  },
  {
    "COUNTRY": "Brazil",
    "CODE": "55",
    "LOCAL": "BR"
  },
  {
    "COUNTRY": "British Indian Ocean Territory",
    "CODE": "246",
    "LOCAL": "IO"
  },
  {
    "COUNTRY": "British Virgin Islands",
    "CODE": "1-284",
    "LOCAL": "VG"
  },
  {
    "COUNTRY": "Brunei",
    "CODE": "673",
    "LOCAL": "BN"
  },
  {
    "COUNTRY": "Bulgaria",
    "CODE": "359",
    "LOCAL": "BG"
  },
  {
    "COUNTRY": "Burkina Faso",
    "CODE": "226",
    "LOCAL": "BF"
  },
  {
    "COUNTRY": "Burundi",
    "CODE": "257",
    "LOCAL": "BI"
  },
  {
    "COUNTRY": "Cambodia",
    "CODE": "855",
    "LOCAL": "KH"
  },
  {
    "COUNTRY": "Cameroon",
    "CODE": "237",
    "LOCAL": "CM"
  },
  {
    "COUNTRY": "Canada",
    "CODE": "1",
    "LOCAL": "CA"
  },
  {
    "COUNTRY": "Cape Verde",
    "CODE": "238",
    "LOCAL": "CV"
  },
  {
    "COUNTRY": "Cayman Islands",
    "CODE": "1-345",
    "LOCAL": "KY"
  },
  {
    "COUNTRY": "Central African Republic",
    "CODE": "236",
    "LOCAL": "CF"
  },
  {
    "COUNTRY": "Chad",
    "CODE": "235",
    "LOCAL": "TD"
  },
  {
    "COUNTRY": "Chile",
    "CODE": "56",
    "LOCAL": "CL"
  },
  {
    "COUNTRY": "China",
    "CODE": "86",
    "LOCAL": "CN"
  },
  {
    "COUNTRY": "Christmas Island",
    "CODE": "61",
    "LOCAL": "CX"
  },
  {
    "COUNTRY": "Cocos Islands",
    "CODE": "61",
    "LOCAL": "CC"
  },
  {
    "COUNTRY": "Colombia",
    "CODE": "57",
    "LOCAL": "CO"
  },
  {
    "COUNTRY": "Comoros",
    "CODE": "269",
    "LOCAL": "KM"
  },
  {
    "COUNTRY": "Cook Islands",
    "CODE": "682",
    "LOCAL": "CK"
  },
  {
    "COUNTRY": "Costa Rica",
    "CODE": "506",
    "LOCAL": "CR"
  },
  {
    "COUNTRY": "Croatia",
    "CODE": "385",
    "LOCAL": "HR"
  },
  {
    "COUNTRY": "Cuba",
    "CODE": "53",
    "LOCAL": "CU"
  },
  {
    "COUNTRY": "Curacao",
    "CODE": "599",
    "LOCAL": "CW"
  },
  {
    "COUNTRY": "Cyprus",
    "CODE": "357",
    "LOCAL": "CY"
  },
  {
    "COUNTRY": "Czech Republic",
    "CODE": "420",
    "LOCAL": "CZ"
  },
  {
    "COUNTRY": "Democratic Republic of the Congo",
    "CODE": "243",
    "LOCAL": "CD"
  },
  {
    "COUNTRY": "Denmark",
    "CODE": "45",
    "LOCAL": "DK"
  },
  {
    "COUNTRY": "Djibouti",
    "CODE": "253",
    "LOCAL": "DJ"
  },
  {
    "COUNTRY": "Dominica",
    "CODE": "1-767",
    "LOCAL": "DM"
  },
  {
    "COUNTRY": "Dominican Republic",
    "CODE": "1-809, 1-829, 1-849",
    "LOCAL": "DO"
  },
  {
    "COUNTRY": "East Timor",
    "CODE": "670",
    "LOCAL": "TL"
  },
  {
    "COUNTRY": "Ecuador",
    "CODE": "593",
    "LOCAL": "EC"
  },
  {
    "COUNTRY": "Egypt",
    "CODE": "20",
    "LOCAL": "EG"
  },
  {
    "COUNTRY": "El Salvador",
    "CODE": "503",
    "LOCAL": "SV"
  },
  {
    "COUNTRY": "Equatorial Guinea",
    "CODE": "240",
    "LOCAL": "GQ"
  },
  {
    "COUNTRY": "Eritrea",
    "CODE": "291",
    "LOCAL": "ER"
  },
  {
    "COUNTRY": "Estonia",
    "CODE": "372",
    "LOCAL": "EE"
  },
  {
    "COUNTRY": "Ethiopia",
    "CODE": "251",
    "LOCAL": "ET"
  },
  {
    "COUNTRY": "Falkland Islands",
    "CODE": "500",
    "LOCAL": "FK"
  },
  {
    "COUNTRY": "Faroe Islands",
    "CODE": "298",
    "LOCAL": "FO"
  },
  {
    "COUNTRY": "Fiji",
    "CODE": "679",
    "LOCAL": "FJ"
  },
  {
    "COUNTRY": "Finland",
    "CODE": "358",
    "LOCAL": "FI"
  },
  {
    "COUNTRY": "France",
    "CODE": "33",
    "LOCAL": "FR"
  },
  {
    "COUNTRY": "French Polynesia",
    "CODE": "689",
    "LOCAL": "PF"
  },
  {
    "COUNTRY": "Gabon",
    "CODE": "241",
    "LOCAL": "GA"
  },
  {
    "COUNTRY": "Gambia",
    "CODE": "220",
    "LOCAL": "GM"
  },
  {
    "COUNTRY": "Georgia",
    "CODE": "995",
    "LOCAL": "GE"
  },
  {
    "COUNTRY": "Germany",
    "CODE": "49",
    "LOCAL": "DE"
  },
  {
    "COUNTRY": "Ghana",
    "CODE": "233",
    "LOCAL": "GH"
  },
  {
    "COUNTRY": "Gibraltar",
    "CODE": "350",
    "LOCAL": "GI"
  },
  {
    "COUNTRY": "Greece",
    "CODE": "30",
    "LOCAL": "GR"
  },
  {
    "COUNTRY": "Greenland",
    "CODE": "299",
    "LOCAL": "GL"
  },
  {
    "COUNTRY": "Grenada",
    "CODE": "1-473",
    "LOCAL": "GD"
  },
  {
    "COUNTRY": "Guam",
    "CODE": "1-671",
    "LOCAL": "GU"
  },
  {
    "COUNTRY": "Guatemala",
    "CODE": "502",
    "LOCAL": "GT"
  },
  {
    "COUNTRY": "Guernsey",
    "CODE": "44-1481",
    "LOCAL": "GG"
  },
  {
    "COUNTRY": "Guinea",
    "CODE": "224",
    "LOCAL": "GN"
  },
  {
    "COUNTRY": "Guinea-Bissau",
    "CODE": "245",
    "LOCAL": "GW"
  },
  {
    "COUNTRY": "Guyana",
    "CODE": "592",
    "LOCAL": "GY"
  },
  {
    "COUNTRY": "Haiti",
    "CODE": "509",
    "LOCAL": "HT"
  },
  {
    "COUNTRY": "Honduras",
    "CODE": "504",
    "LOCAL": "HN"
  },
  {
    "COUNTRY": "Hong Kong",
    "CODE": "852",
    "LOCAL": "HK"
  },
  {
    "COUNTRY": "Hungary",
    "CODE": "36",
    "LOCAL": "HU"
  },
  {
    "COUNTRY": "Iceland",
    "CODE": "354",
    "LOCAL": "IS"
  },
  {
    "COUNTRY": "India",
    "CODE": "91",
    "LOCAL": "IN"
  },
  {
    "COUNTRY": "Indonesia",
    "CODE": "62",
    "LOCAL": "ID"
  },
  {
    "COUNTRY": "Iran",
    "CODE": "98",
    "LOCAL": "IR"
  },
  {
    "COUNTRY": "Iraq",
    "CODE": "964",
    "LOCAL": "IQ"
  },
  {
    "COUNTRY": "Ireland",
    "CODE": "353",
    "LOCAL": "IE"
  },
  {
    "COUNTRY": "Isle of Man",
    "CODE": "44-1624",
    "LOCAL": "IM"
  },
  {
    "COUNTRY": "Israel",
    "CODE": "972",
    "LOCAL": "IL"
  },
  {
    "COUNTRY": "Italy",
    "CODE": "39",
    "LOCAL": "IT"
  },
  {
    "COUNTRY": "Ivory Coast",
    "CODE": "225",
    "LOCAL": "CI"
  },
  {
    "COUNTRY": "Jamaica",
    "CODE": "1-876",
    "LOCAL": "JM"
  },
  {
    "COUNTRY": "Japan",
    "CODE": "81",
    "LOCAL": "JP"
  },
  {
    "COUNTRY": "Jersey",
    "CODE": "44-1534",
    "LOCAL": "JE"
  },
  {
    "COUNTRY": "Jordan",
    "CODE": "962",
    "LOCAL": "JO"
  },
  {
    "COUNTRY": "Kazakhstan",
    "CODE": "7",
    "LOCAL": "KZ"
  },
  {
    "COUNTRY": "Kenya",
    "CODE": "254",
    "LOCAL": "KE"
  },
  {
    "COUNTRY": "Kiribati",
    "CODE": "686",
    "LOCAL": "KI"
  },
  {
    "COUNTRY": "Kosovo",
    "CODE": "383",
    "LOCAL": "XK"
  },
  {
    "COUNTRY": "Kuwait",
    "CODE": "965",
    "LOCAL": "KW"
  },
  {
    "COUNTRY": "Kyrgyzstan",
    "CODE": "996",
    "LOCAL": "KG"
  },
  {
    "COUNTRY": "Laos",
    "CODE": "856",
    "LOCAL": "LA"
  },
  {
    "COUNTRY": "Latvia",
    "CODE": "371",
    "LOCAL": "LV"
  },
  {
    "COUNTRY": "Lebanon",
    "CODE": "961",
    "LOCAL": "LB"
  },
  {
    "COUNTRY": "Lesotho",
    "CODE": "266",
    "LOCAL": "LS"
  },
  {
    "COUNTRY": "Liberia",
    "CODE": "231",
    "LOCAL": "LR"
  },
  {
    "COUNTRY": "Libya",
    "CODE": "218",
    "LOCAL": "LY"
  },
  {
    "COUNTRY": "Liechtenstein",
    "CODE": "423",
    "LOCAL": "LI"
  },
  {
    "COUNTRY": "Lithuania",
    "CODE": "370",
    "LOCAL": "LT"
  },
  {
    "COUNTRY": "Luxembourg",
    "CODE": "352",
    "LOCAL": "LU"
  },
  {
    "COUNTRY": "Macau",
    "CODE": "853",
    "LOCAL": "MO"
  },
  {
    "COUNTRY": "Macedonia",
    "CODE": "389",
    "LOCAL": "MK"
  },
  {
    "COUNTRY": "Madagascar",
    "CODE": "261",
    "LOCAL": "MG"
  },
  {
    "COUNTRY": "Malawi",
    "CODE": "265",
    "LOCAL": "MW"
  },
  {
    "COUNTRY": "Malaysia",
    "CODE": "60",
    "LOCAL": "MY"
  },
  {
    "COUNTRY": "Maldives",
    "CODE": "960",
    "LOCAL": "MV"
  },
  {
    "COUNTRY": "Mali",
    "CODE": "223",
    "LOCAL": "ML"
  },
  {
    "COUNTRY": "Malta",
    "CODE": "356",
    "LOCAL": "MT"
  },
  {
    "COUNTRY": "Marshall Islands",
    "CODE": "692",
    "LOCAL": "MH"
  },
  {
    "COUNTRY": "Mauritania",
    "CODE": "222",
    "LOCAL": "MR"
  },
  {
    "COUNTRY": "Mauritius",
    "CODE": "230",
    "LOCAL": "MU"
  },
  {
    "COUNTRY": "Mayotte",
    "CODE": "262",
    "LOCAL": "YT"
  },
  {
    "COUNTRY": "Mexico",
    "CODE": "52",
    "LOCAL": "MX"
  },
  {
    "COUNTRY": "Micronesia",
    "CODE": "691",
    "LOCAL": "FM"
  },
  {
    "COUNTRY": "Moldova",
    "CODE": "373",
    "LOCAL": "MD"
  },
  {
    "COUNTRY": "Monaco",
    "CODE": "377",
    "LOCAL": "MC"
  },
  {
    "COUNTRY": "Mongolia",
    "CODE": "976",
    "LOCAL": "MN"
  },
  {
    "COUNTRY": "Montenegro",
    "CODE": "382",
    "LOCAL": "ME"
  },
  {
    "COUNTRY": "Montserrat",
    "CODE": "1-664",
    "LOCAL": "MS"
  },
  {
    "COUNTRY": "Morocco",
    "CODE": "212",
    "LOCAL": "MA"
  },
  {
    "COUNTRY": "Mozambique",
    "CODE": "258",
    "LOCAL": "MZ"
  },
  {
    "COUNTRY": "Myanmar",
    "CODE": "95",
    "LOCAL": "MM"
  },
  {
    "COUNTRY": "Namibia",
    "CODE": "264",
    "LOCAL": "NA"
  },
  {
    "COUNTRY": "Nauru",
    "CODE": "674",
    "LOCAL": "NR"
  },
  {
    "COUNTRY": "Nepal",
    "CODE": "977",
    "LOCAL": "NP"
  },
  {
    "COUNTRY": "Netherlands",
    "CODE": "31",
    "LOCAL": "NL"
  },
  {
    "COUNTRY": "Netherlands Antilles",
    "CODE": "599",
    "LOCAL": "AN"
  },
  {
    "COUNTRY": "New Caledonia",
    "CODE": "687",
    "LOCAL": "NC"
  },
  {
    "COUNTRY": "New Zealand",
    "CODE": "64",
    "LOCAL": "NZ"
  },
  {
    "COUNTRY": "Nicaragua",
    "CODE": "505",
    "LOCAL": "NI"
  },
  {
    "COUNTRY": "Niger",
    "CODE": "227",
    "LOCAL": "NE"
  },
  {
    "COUNTRY": "Nigeria",
    "CODE": "234",
    "LOCAL": "NG"
  },
  {
    "COUNTRY": "Niue",
    "CODE": "683",
    "LOCAL": "NU"
  },
  {
    "COUNTRY": "North Korea",
    "CODE": "850",
    "LOCAL": "KP"
  },
  {
    "COUNTRY": "Northern Mariana Islands",
    "CODE": "1-670",
    "LOCAL": "MP"
  },
  {
    "COUNTRY": "Norway",
    "CODE": "47",
    "LOCAL": "NO"
  },
  {
    "COUNTRY": "Oman",
    "CODE": "968",
    "LOCAL": "OM"
  },
  {
    "COUNTRY": "Pakistan",
    "CODE": "92",
    "LOCAL": "PK"
  },
  {
    "COUNTRY": "Palau",
    "CODE": "680",
    "LOCAL": "PW"
  },
  {
    "COUNTRY": "Palestine",
    "CODE": "970",
    "LOCAL": "PS"
  },
  {
    "COUNTRY": "Panama",
    "CODE": "507",
    "LOCAL": "PA"
  },
  {
    "COUNTRY": "Papua New Guinea",
    "CODE": "675",
    "LOCAL": "PG"
  },
  {
    "COUNTRY": "Paraguay",
    "CODE": "595",
    "LOCAL": "PY"
  },
  {
    "COUNTRY": "Peru",
    "CODE": "51",
    "LOCAL": "PE"
  },
  {
    "COUNTRY": "Philippines",
    "CODE": "63",
    "LOCAL": "PH"
  },
  {
    "COUNTRY": "Pitcairn",
    "CODE": "64",
    "LOCAL": "PN"
  },
  {
    "COUNTRY": "Poland",
    "CODE": "48",
    "LOCAL": "PL"
  },
  {
    "COUNTRY": "Portugal",
    "CODE": "351",
    "LOCAL": "PT"
  },
  {
    "COUNTRY": "Puerto Rico",
    "CODE": "1-787, 1-939",
    "LOCAL": "PR"
  },
  {
    "COUNTRY": "Qatar",
    "CODE": "974",
    "LOCAL": "QA"
  },
  {
    "COUNTRY": "Republic of the Congo",
    "CODE": "242",
    "LOCAL": "CG"
  },
  {
    "COUNTRY": "Reunion",
    "CODE": "262",
    "LOCAL": "RE"
  },
  {
    "COUNTRY": "Romania",
    "CODE": "40",
    "LOCAL": "RO"
  },
  {
    "COUNTRY": "Russia",
    "CODE": "7",
    "LOCAL": "RU"
  },
  {
    "COUNTRY": "Rwanda",
    "CODE": "250",
    "LOCAL": "RW"
  },
  {
    "COUNTRY": "Saint Barthelemy",
    "CODE": "590",
    "LOCAL": "BL"
  },
  {
    "COUNTRY": "Saint Helena",
    "CODE": "290",
    "LOCAL": "SH"
  },
  {
    "COUNTRY": "Saint Kitts and Nevis",
    "CODE": "1-869",
    "LOCAL": "KN"
  },
  {
    "COUNTRY": "Saint Lucia",
    "CODE": "1-758",
    "LOCAL": "LC"
  },
  {
    "COUNTRY": "Saint Martin",
    "CODE": "590",
    "LOCAL": "MF"
  },
  {
    "COUNTRY": "Saint Pierre and Miquelon",
    "CODE": "508",
    "LOCAL": "PM"
  },
  {
    "COUNTRY": "Saint Vincent and the Grenadines",
    "CODE": "1-784",
    "LOCAL": "VC"
  },
  {
    "COUNTRY": "Samoa",
    "CODE": "685",
    "LOCAL": "WS"
  },
  {
    "COUNTRY": "San Marino",
    "CODE": "378",
    "LOCAL": "SM"
  },
  {
    "COUNTRY": "Sao Tome and Principe",
    "CODE": "239",
    "LOCAL": "ST"
  },
  {
    "COUNTRY": "Saudi Arabia",
    "CODE": "966",
    "LOCAL": "SA"
  },
  {
    "COUNTRY": "Senegal",
    "CODE": "221",
    "LOCAL": "SN"
  },
  {
    "COUNTRY": "Serbia",
    "CODE": "381",
    "LOCAL": "RS"
  },
  {
    "COUNTRY": "Seychelles",
    "CODE": "248",
    "LOCAL": "SC"
  },
  {
    "COUNTRY": "Sierra Leone",
    "CODE": "232",
    "LOCAL": "SL"
  },
  {
    "COUNTRY": "Singapore",
    "CODE": "65",
    "LOCAL": "SG"
  },
  {
    "COUNTRY": "Sint Maarten",
    "CODE": "1-721",
    "LOCAL": "SX"
  },
  {
    "COUNTRY": "Slovakia",
    "CODE": "421",
    "LOCAL": "SK"
  },
  {
    "COUNTRY": "Slovenia",
    "CODE": "386",
    "LOCAL": "SI"
  },
  {
    "COUNTRY": "Solomon Islands",
    "CODE": "677",
    "LOCAL": "SB"
  },
  {
    "COUNTRY": "Somalia",
    "CODE": "252",
    "LOCAL": "SO"
  },
  {
    "COUNTRY": "South Africa",
    "CODE": "27",
    "LOCAL": "ZA"
  },
  {
    "COUNTRY": "South Korea",
    "CODE": "82",
    "LOCAL": "KR"
  },
  {
    "COUNTRY": "South Sudan",
    "CODE": "211",
    "LOCAL": "SS"
  },
  {
    "COUNTRY": "Spain",
    "CODE": "34",
    "LOCAL": "ES"
  },
  {
    "COUNTRY": "Sri Lanka",
    "CODE": "94",
    "LOCAL": "LK"
  },
  {
    "COUNTRY": "Sudan",
    "CODE": "249",
    "LOCAL": "SD"
  },
  {
    "COUNTRY": "Suriname",
    "CODE": "597",
    "LOCAL": "SR"
  },
  {
    "COUNTRY": "Svalbard and Jan Mayen",
    "CODE": "47",
    "LOCAL": "SJ"
  },
  {
    "COUNTRY": "Swaziland",
    "CODE": "268",
    "LOCAL": "SZ"
  },
  {
    "COUNTRY": "Sweden",
    "CODE": "46",
    "LOCAL": "SE"
  },
  {
    "COUNTRY": "Switzerland",
    "CODE": "41",
    "LOCAL": "CH"
  },
  {
    "COUNTRY": "Syria",
    "CODE": "963",
    "LOCAL": "SY"
  },
  {
    "COUNTRY": "Taiwan",
    "CODE": "886",
    "LOCAL": "TW"
  },
  {
    "COUNTRY": "Tajikistan",
    "CODE": "992",
    "LOCAL": "TJ"
  },
  {
    "COUNTRY": "Tanzania",
    "CODE": "255",
    "LOCAL": "TZ"
  },
  {
    "COUNTRY": "Thailand",
    "CODE": "66",
    "LOCAL": "TH"
  },
  {
    "COUNTRY": "Togo",
    "CODE": "228",
    "LOCAL": "TG"
  },
  {
    "COUNTRY": "Tokelau",
    "CODE": "690",
    "LOCAL": "TK"
  },
  {
    "COUNTRY": "Tonga",
    "CODE": "676",
    "LOCAL": "TO"
  },
  {
    "COUNTRY": "Trinidad and Tobago",
    "CODE": "1-868",
    "LOCAL": "TT"
  },
  {
    "COUNTRY": "Tunisia",
    "CODE": "216",
    "LOCAL": "TN"
  },
  {
    "COUNTRY": "Turkey",
    "CODE": "90",
    "LOCAL": "TR"
  },
  {
    "COUNTRY": "Turkmenistan",
    "CODE": "993",
    "LOCAL": "TM"
  },
  {
    "COUNTRY": "Turks and Caicos Islands",
    "CODE": "1-649",
    "LOCAL": "TC"
  },
  {
    "COUNTRY": "Tuvalu",
    "CODE": "688",
    "LOCAL": "TV"
  },
  {
    "COUNTRY": "U.S. Virgin Islands",
    "CODE": "1-340",
    "LOCAL": "VI"
  },
  {
    "COUNTRY": "Uganda",
    "CODE": "256",
    "LOCAL": "UG"
  },
  {
    "COUNTRY": "Ukraine",
    "CODE": "380",
    "LOCAL": "UA"
  },
  {
    "COUNTRY": "United Arab Emirates",
    "CODE": "971",
    "LOCAL": "AE"
  },
  {
    "COUNTRY": "United Kingdom",
    "CODE": "44",
    "LOCAL": "GB"
  },
  {
    "COUNTRY": "United States",
    "CODE": "1",
    "LOCAL": "US"
  },
  {
    "COUNTRY": "Uruguay",
    "CODE": "598",
    "LOCAL": "UY"
  },
  {
    "COUNTRY": "Uzbekistan",
    "CODE": "998",
    "LOCAL": "UZ"
  },
  {
    "COUNTRY": "Vanuatu",
    "CODE": "678",
    "LOCAL": "VU"
  },
  {
    "COUNTRY": "Vatican",
    "CODE": "379",
    "LOCAL": "VA"
  },
  {
    "COUNTRY": "Venezuela",
    "CODE": "58",
    "LOCAL": "VE"
  },
  {
    "COUNTRY": "Vietnam",
    "CODE": "84",
    "LOCAL": "VN"
  },
  {
    "COUNTRY": "Wallis and Futuna",
    "CODE": "681",
    "LOCAL": "WF"
  },
  {
    "COUNTRY": "Western Sahara",
    "CODE": "212",
    "LOCAL": "EH"
  },
  {
    "COUNTRY": "Yemen",
    "CODE": "967",
    "LOCAL": "YE"
  },
  {
    "COUNTRY": "Zambia",
    "CODE": "260",
    "LOCAL": "ZM"
  },
  {
    "COUNTRY": "Zimbabwe",
    "CODE": "263",
    "LOCAL": "ZW"
  }
];

export default phonecode;